import styled from 'styled-components';
import { Colors } from '../../colors';
export const Container = styled.div `
  position: relative;

  height: ${({ height }) => height}px;

  background: ${Colors.GS400};
`;
export const Bar = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  transition: width 0.3s ease-in-out;

  height: 100%;

  background: ${({ color }) => color || Colors.GS1000};
`;
